import React from 'react';
import Alert from 'react-bootstrap/Alert';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { AppNotice, dismissNotice } from 'services/notices/slice';
import styles from './AppNotices.module.css';

const AppNotices = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const notices = useSelector((state: { notices: AppNotice[] }) => state.notices);

  if (!notices.length) {
    return null;
  }

  return (
    <div className={styles.notices}>
      {
        notices.map(notice => (
          <Alert
            dismissible
            key={notice.id}
            onClose={() => dispatch(dismissNotice(notice.id))}
            variant="danger"
          >
            {notice.message || t('couldNotSaveTask')}
          </Alert>
        ))
      }
    </div>
  );
};

export default AppNotices;
